import { render, staticRenderFns } from "./edit-venture-partner-modal.vue?vue&type=template&id=4b29c3a8"
import script from "./edit-venture-partner-modal.vue?vue&type=script&lang=js"
export * from "./edit-venture-partner-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports